<footer>
  <div class="container-fluid py-5 px-3">
    <div class="row align-items-center">
      <div class="col-1">
        <img
          src="assets/img/Home/svg/Ico_super.svg"
          alt=""
          class="img-financiera"
          />
        </div>
        <div class="col-10">
          <div class="">
            <div
              class="d-flex flex-column flex-lg-row align-items-center justify-content-center"
              >
              <h3 class="me-lg-3 text-center text-lg-start">
                Visítanos y conoce lo que tenemos para ti
              </h3>

              <div class="my-3 my-lg-0">
                <a
                  href="https://www.facebook.com/bancoldex"
                  target="https://www.facebook.com/bancoldex"
                  class="hvr-grow mx-1"
                  >
                  <img
                    src="assets/img/Home/svg/Ico_facebook.svg"
                    alt=""
                    class="img-ico-redes d-flex mx-auto"
                    />
                  </a>
                  <a
                    href="https://twitter.com/bancoldex"
                    target="https://twitter.com/bancoldex"
                    class="hvr-grow mx-1"
                    >
                    <img
                      src="assets/img/Home/svg/Ico_twitter.svg"
                      alt=""
                      class="img-ico-redes d-flex mx-auto"
                      />
                    </a>
                    <a
                      href="https://www.linkedin.com/company/grupo-bancoldex"
                      target="https://www.linkedin.com/company/grupo-bancoldex"
                      class="hvr-grow mx-1"
                      >
                      <img
                        src="assets/img/Home/svg/Ico_linkedin.svg"
                        alt=""
                        class="img-ico-redes d-flex mx-auto"
                        />
                      </a>
                      <a
                        href="https://www.instagram.com/bancoldex"
                        target="https://www.instagram.com/bancoldex"
                        class="hvr-grow mx-1"
                        >
                        <img
                          src="assets/img/Home/svg/Ico_instagram.svg"
                          alt=""
                          class="img-ico-redes d-flex mx-auto"
                          />
                        </a>
                      </div>
                    </div>
                  </div>


                  <ul class="d-flex flex-column flex-lg-row align-items-center justify-content-between mt-3 mt-lg-5">
                    <li class="listFooter">
                      <a class="hvr-grow btn btn_link gif-button-7"
                        href="https://www.bancoldex.com/es/contactanos/defensor-del-consumidor-financiero-3740"
                        target="https://www.bancoldex.com/es/contactanos/defensor-del-consumidor-financiero-3740">Defensor del
                      Consumidor Financiero</a>
                      <div id="contenido-7" class="oculto-7">
                        <img src="assets/video/GIF/07_Defensor_del_cosumidor_financiero.gif" alt="" class="shadow">
                      </div>
                    </li>
                    <li class="listFooter">
                      <a class="hvr-grow btn btn_link info_hover if gif-button-8">Información de contacto</a>
                      <div id="contenido-8" class="oculto-8">
                        <img src="assets/video/GIF/08_Informacion_de_contacto.gif" alt="" class="shadow">
                      </div>
                    </li>
                    <li class="listFooter">
                      <a class="hvr-grow btn btn_link info_hover la gif-button-9">Líneas de atención</a>
                      <div id="contenido-9" class="oculto-9">
                        <img src="assets/video/GIF/09_lineas_de_atencion.gif" alt="" class="shadow">
                      </div>
                    </li>
                    <li class="listFooter">
                      <a onclick="window.scrollTo(0,0)" routerLink="/preguntas-frecuentes"
                      class="hvr-grow btn btn_link gif-button-10">Preguntas frecuentes</a>
                      <div id="contenido-10" class="oculto-10">
                        <img src="assets/video/GIF/10_preguntas_frecuentes.gif" alt="" class="shadow">
                      </div>
                    </li>
                  </ul>

                  <!-- <div class="row mt-4 mt-lg-5 align-items-center">
                  <div class="col-12 col-xl-4 mb-4 mb-xl-0">
                    <a target="_blank" href="https://www.gov.co/" class="btn w-100 hvr-shrink">
                      <img
                        src="assets/img/Home/svg/LogoGobierno.svg"
                        alt=""
                        class="img-fluid logoGobierno"
                        />
                      </a>
                    </div>
                    <div class="col-12 col-xl-4 mb-4 mb-xl-0">
                      <a target="_blank" href="https://www.bancoldex.com" class="btn w-100 hvr-shrink">
                        <img
                          src="assets/img/Home/svg/Logo_bancoldex.svg"
                          alt=""
                          class="img-fluid logoBancoldex"
                          />
                        </a>
                      </div>
                      <div class="col-12 col-xl-4">
                        <a target="_blank" href="https://www.fintechamericas.co/" class="btn w-100 hvr-shrink">
                          <img
                            src="assets/img/Home/svg/LogoFintech.svg"
                            alt=""
                            class="img-fluid logoFintech"
                            />
                          </a>
                        </div>
                      </div> -->

                      <div class="mt-3 clusterlogos">
                        <div class="row mt-4 mt-lg-5 align-items-center">
                          @for (logo of listaLogosFooter; track logo) {
                            <div class="col-12 col-xl-4 ">
                              <a  [href]="logo.url" target="_blank" class="btn w-100 hvr-shrink">
                                <img [src]="logo.imagen"
                                  [alt]="logo.descripcion"  class="img-fluid">
                                </a>
                              </div>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center mt-0 mt-xl-2">
                    <p class="copy">
                      Copyright © Todos los derechos reservados a
                      <a
                        href="https://www.bancoldex.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="btn-link"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Tooltip on top"
                        title="https://www.bancoldex.com/"
                        >
                        Bancóldex</a
                        >
                        - desarrollado por
                        <a
                          href="https://smartsoft.la/"
                          target="_blank"
                          rel="noopener noreferrer"
                          class="btn-link"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Tooltip on top"
                          title="https://smartsoft.la/"
                          >
                          SmartSoft</a
                          >
                        </p>
                      </div>
                    </footer>
                    <div class="modal fade modal_info" tabindex="-1" id="politicasModal">
                      <div class="modal-dialog modal-dialog-centered modal-md">
                        <div class="modal-content">
                          <div class="modal-header">
                            <h5 class="modal-title modal_info_title"></h5>
                          </div>
                          <div class="modal-body modal_info_body"></div>
                          <div class="modal-footer">
                            <button
                              type="button"
                              class="btn btn-primary"
                              data-bs-dismiss="modal"
                              (click)="closeModal()"
                              >
                              Salir
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
